module.exports = __webpack_public_path__ + "img/12_106.69511982.png";